import { getPPAuthToken, ResponseModel } from '@r-and-a-shared-ui/utils';
import { ActionHandlerParams } from '../../types';
import {
  PP_UpdateInputSchema,
  pp_championshipPlayerDefaultValuesUpdate,
  pp_championshipCaddieDefaultValuesUpdate,
} from '@r-and-a-shared-ui/randa-trpc-server/input-schemas';
import { pp_genericMutationHandlerWithFormValidation } from '../pp-form-action-mutation-handlers';
import { getBearerToken } from '@r-and-a-shared-ui/auth-client';

export const handle = async (
  params: ActionHandlerParams,
): Promise<ResponseModel> => {
  const authTokenMutation = params.authTokenMutation;

  if (authTokenMutation) {
    params.bearerToken = await getPPAuthToken(authTokenMutation?.mutateAsync);
  }

  params.cognitoToken = await getBearerToken();
  const resultData = await pp_genericMutationHandlerWithFormValidation(
    params,
    PP_UpdateInputSchema,
    resolveDefaultValuesUpdate(params),
  );
  if (resultData?.hasErrors) {
    return resultData;
  }

  return resultData;
};

const resolveDefaultValuesUpdate = (params: ActionHandlerParams) => {
  if (params.resource?.toLowerCase().includes('caddie')) {
    return pp_championshipCaddieDefaultValuesUpdate;
  }

  return pp_championshipPlayerDefaultValuesUpdate;
};

export default handle;
